import React, { useEffect } from 'react';
import { validateTransferToken } from './authFunctions';
import { Progress } from '@awesomecomponents/mux';
import * as HttpStatus from 'http-status-codes';

import packageJson from '../../package.json';
const basePath = packageJson.homepage;

const Authenticator = ({
  transfer_token,
  history,
  business_unit,
  language,
  form_name,
  setLang,
  setIsAuthenticated,
  oidc,
}) => {
  const lang = language === 'fr' ? 'fr-CA' : 'en-CA';
  useEffect(() => {
    const handleAuth = async () => {
      try {
        const response = await validateTransferToken(transfer_token, business_unit, form_name);

        const { transferInResponse } = response;

        const isCiamSession = transferInResponse?.hasOwnProperty('CIAM');

        // Conditions that will determine if step up is not needed
        // 1. Form is not e-bene-2
        // 2. Response.transferInResponse has no CIAM property indicating that on CIAM session exist
        // 3. CIAM.arm has 'otp' element indicating that step up has been done

        // HOTFIX: Skip all step up
        const isSteppedUp =
          true || form_name !== 'e-bene-2' || !isCiamSession || transferInResponse?.CIAM.amr.includes('otp');

        if (isCiamSession) {
          sessionStorage.setItem('maxSessionExpirationTime', transferInResponse.CIAM.maxSessionExpirationTime);
        }

        if (!isSteppedUp) {
          await oidc.performStepUpAuthentication(
            lang,
            form_name,
            transferInResponse.Identity.clientNumber,
            transferInResponse.Identity.certificate,
          );

          // Return function to avoid displaying 401 error page when stepping up
          return;
        }

        if (response.status === HttpStatus.OK && isSteppedUp) {
          sessionStorage.setItem('isAuthenticated', true);
          setLang(lang);
          setIsAuthenticated(true);
          history.push(`${basePath}/${business_unit}/${form_name}`);
        } else {
          setLang(lang);
          setIsAuthenticated(false);
          history.push(`${basePath}/error`);
        }
      } catch {
        setLang(lang);
        setIsAuthenticated(false);
        history.push(`${basePath}/error`);
      }
    };

    handleAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Progress />
    </div>
  );
};

export default Authenticator;
